import { render, staticRenderFns } from "./orderForm.vue?vue&type=template&id=2b61e48c&scoped=true&"
import script from "./orderForm.vue?vue&type=script&lang=js&"
export * from "./orderForm.vue?vue&type=script&lang=js&"
import style0 from "./orderForm.vue?vue&type=style&index=0&id=2b61e48c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61e48c",
  null
  
)

export default component.exports